module.exports = __webpack_public_path__ + "static/media/login.f50e7a3e.PNG";